<template>
  <v-container>
    <RouterLink :to="props.link">
      <v-row>
        <v-col cols="3" lg="2" xl="1" class="d-flex justify-center">
          <v-avatar size="50" :color="props.color + '-lighten-1'">
            <v-icon :color="props.color">{{ props.icon }}</v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="9" lg="10" xl="11">
          <h2 class="text-h5">{{ props.title }}</h2>
          <p class="text-secondary-darken-1">
            {{ props.description }}
          </p>
        </v-col>
      </v-row>
    </RouterLink>
  </v-container>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string
  description: string
  icon: string
  color: string
  link: string
}>()
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
}
</style>
